import React from "react";
import { getImageSrc } from "../../utils";
import {
  Box,
  Input,
  Button,
  Spinner,
  Row,
  Col,
  Dropzone,
  Typography,
} from "@commonsku/styles";
import _ from "lodash";

const sectionDetails = {
  "LOGINPAGE-AD": {
    w: 555,
    h: 300,
    title: "Returning user - top box",
    desc: "Appears on the top right of the login screen for users with a prior commonsku session.",
  },
  "LOGINPAGE-AD-BOTTOM": {
    w: 555,
    h: 200,
    title: "Returning user - bottom box (new)",
    desc: "Appears below the top box on the returning user screen.",
  },
  "LOGINPAGE-AD-NEW-USER": {
    w: 555,
    h: 530,
    title: "Prospect - main box (new)",
    desc: "Appears on the login screen for first time vistors and incognito sessions.",
  },
};

export const LoginPageSettings = ({
  loading,
  setting_name,
  settings,
  addSetting,
  updateSetting,
  onUploadImg,
}) => {
  function getSetting(settingName) {
    if (
      settings &&
      settings.data &&
      Array.isArray(settings.data) &&
      settings.data.length > 0
    ) {
      settings = settings.data;
    }
    return _.find(settings, { setting_name: settingName });
  }

  function renderImgPreview(imgUrl, height) {
    return (
      <div
        className="login_crd"
        style={{
          background: `url('${imgUrl}') no-repeat center center`,
          backgroundSize: "cover",
          height: `${height}px`,
          minHeight: `${height}px`,
          //   height: `${height}px !important`,
        }}
      >
        <img src="/images/xtrnl.svg" />
      </div>
    );
  }

  const sections = [
    "LOGINPAGE-AD",
    "LOGINPAGE-AD-BOTTOM",
    "LOGINPAGE-AD-NEW-USER",
  ];

  return sections.map((section) => {
    let s = getSetting(section);
    let details = sectionDetails[section];
    return loading ? (
      <Spinner />
    ) : s && s.marketing_setting_id ? (
      <Row>
        <Col padded xs>
          <Box
            key={"loginpage_card_0_" + s.marketing_setting_id}
            style={{ padding: 20 }}
          >
            {s.error ? (
              <Row>
                <Col padded xs>
                  <p
                    style={{
                      textAlign: "center",
                      color: "red",
                      fontSize: "1.5em",
                      fontWeight: "bold",
                      margin: 0,
                      marginBottom: 10,
                    }}
                  >
                    {s.error}
                  </p>
                </Col>
              </Row>
            ) : null}

            <Row>
              <Col padded xs>
                <Typography.Span
                  style={{ fontWeight: "bold", fontSize: "1.8rem" }}
                >
                  {details.title}
                </Typography.Span>
              </Col>
            </Row>
            <Row>
              <Col padded xs>
                <Typography.Span>{details.desc}</Typography.Span>
              </Col>
            </Row>
            <div
              style={{
                width: details.w,
                height: details.h + 50,
                marginLeft: "auto",
                marginRight: "auto",
                marginBottom: 20,
              }}
            >
              <Dropzone
                onDrop={onUploadImg(s.marketing_setting_id)}
                multiple={false}
                accept="image/*"
                style={{
                  width: details.w,
                  height: details.h,
                  maxHeight: details.h,
                  borderWidth: 2,
                  borderColor: "rgb(102, 102, 102)",
                  borderStyle: s.file_data ? "" : "dashed",
                  borderRadius: 5,
                  textAlign: "center",
                  marginBottom: 20,
                }}
              >
                <>
                  {loading ? (
                    <div className="small-12 text-center">
                      <br />
                      <img src="/images/gears.gif" />
                      <br />
                    </div>
                  ) : s.file_data ? (
                    renderImgPreview(
                      getImageSrc(s.file_data, "original"),
                      details.h,
                    )
                  ) : (
                    "Upload Image"
                  )}
                </>
              </Dropzone>
              <Input
                placeholder="URL"
                value={s.link}
                onChange={(e) => {
                  updateSetting(s.marketing_setting_id, {
                    link: e.target.value,
                    active: 1,
                    update_remote: false,
                  });
                }}
                onBlur={(e) => {
                  updateSetting(s.marketing_setting_id, {
                    link: e.target.value,
                    active: 1,
                  });
                }}
              />
            </div>
            <div style={{ color: "#A4ABAE", textAlign: "center" }}>
              <span style={{ fontWeight: "bold" }}>Image Dimensions</span>
              <br />
              Width: {details.w}, Height: {details.h}
            </div>
          </Box>
        </Col>
      </Row>
    ) : section === "LOGINPAGE-AD" ? (
      <Row className="mt-20">
        <Col padded xs>
          <Button
            style={{ textAlign: "center" }}
            size={"small"}
            onClick={(e) => {
              if (setting_name) {
                addSetting({ setting_name: setting_name });
              }
            }}
          >
            + New
          </Button>
        </Col>
      </Row>
    ) : null;
  });
};
